import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

interface DashboardCardHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  infoTooltip?: string;
}

export const DashboardCardHeader: React.FC<DashboardCardHeaderProps> = ({
  title,
  subtitle,
  actions,
  infoTooltip,
}) => (
  <div className="dashboard-card-header">
    <div className="dashboard-card-header-left">
      <h3 className="dashboard-card-header-title">{title}</h3>
      {subtitle && <p className="dashboard-card-header-subtitle">{subtitle}</p>}
    </div>
    <div className="dashboard-card-header-actions">
      {actions}
      {infoTooltip && (
        <Tooltip title={infoTooltip} placement="top">
          <span
            className="dashboard-card-header-info"
            role="img"
            aria-label="Info"
          >
            <InfoCircleOutlined />
          </span>
        </Tooltip>
      )}
    </div>
  </div>
);
